import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';

import { validateColorContrast } from '@plugins/client/colors/color-utils';
import { AnswerDto } from '@plugins/faq-lib/types';

import { DECORATIVE_CONTRAST_TOKEN } from '../../../app.module';
import { STATUS_COLOR } from '../../models/status.model';
import { InstanceState } from '../../store/instance/instance.state';

@Component({
  selector: 'faq-answer-status',
  standalone: false,
  templateUrl: './answer-status.component.html',
  styleUrl: './answer-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnswerStatusComponent {
  readonly answer = input.required<AnswerDto>();

  private readonly store = inject(Store);
  private readonly contrastRatio = inject(DECORATIVE_CONTRAST_TOKEN);

  private readonly instance = toSignal(
    this.store.select(InstanceState.instance),
  );

  readonly status = computed(() => {
    const answer = this.answer();
    const instance = this.instance();

    if (answer.correct) {
      return 'label_answered';
    }
    if (answer.totalUpVotes > instance.settings.potentialMinVotes) {
      return 'label_potentially_answered';
    }

    return 'label_active';
  });

  readonly color = computed(() => {
    return validateColorContrast(
      this.instance().settings[STATUS_COLOR[this.status()]],
      this.contrastRatio,
    );
  });
}
